/**
 * To-dos der Übersicht (Board „Preisautomatik · Übersicht“) aus echten Zählern je Apartment:
 * fehlgeschlagene Anfragen, Ziel noch nicht bestätigt, Tage ohne bestätigten Stand – mit dem Weg in
 * den Verlauf oder den Monat. Ohne offene Punkte sagt eine Karte genau das (die Zähler sind geladen).
 */
import { Link } from '@tanstack/react-router';
import { cn } from '@/shared/lib/cn';
import type { Todo } from './todoModel';

export function OverviewTodos({ items }: { items: Todo[] }) {
  if (items.length === 0) {
    return (
      <p className="bg-card border-hairline rounded-tile shadow-float border p-5 text-sm font-semibold">
        Keine offenen Punkte – keine fehlgeschlagene Anfrage, kein unbestätigtes Ziel.
      </p>
    );
  }
  return (
    <div className="grid gap-3.5 [grid-template-columns:repeat(auto-fill,minmax(260px,1fr))]">
      {items.map((todo, index) => (
        <article
          key={todo.propertyId}
          className="bg-card rounded-tile shadow-float flex flex-col gap-2 p-[18px]"
        >
          <span className="flex items-baseline gap-2.5">
            <span
              className={cn(
                'font-serif text-2xl font-bold',
                todo.tone === 'red' ? 'text-sealwax' : 'text-amber-ink',
              )}
            >
              {index + 1}
            </span>
            <span
              className={cn(
                'rounded-pill inline-flex h-[22px] items-center px-2.5 text-[11px] font-bold',
                todo.tone === 'red'
                  ? 'bg-sealwax-tint text-sealwax'
                  : 'bg-amber-tint text-amber-ink',
              )}
            >
              {todo.kind}
            </span>
          </span>
          <span className="text-base font-bold">{todo.title}</span>
          <span className="text-ink-soft grow text-[13px]">{todo.sub}</span>
          {todo.target === 'month' ? (
            <Link
              to="/availability-distribution"
              search={{ apartment: todo.propertyId }}
              className={ACTION}
            >
              Im Kalender ansehen →
            </Link>
          ) : (
            <Link
              to="/dynamic-pricing/history"
              search={{ apartment: todo.propertyId }}
              className={ACTION}
            >
              Im Verlauf ansehen →
            </Link>
          )}
        </article>
      ))}
    </div>
  );
}

const ACTION =
  'rounded-pill bg-card-alt text-ink flex h-11 items-center self-start px-3.5 text-[13px] font-bold';
